import { initialListPaginationMeta } from "utils/helpers/pagination";

import { UnderCarriageForm, UnderCarriageState } from "../types";

export const initialUnderCarriageForm: UnderCarriageForm = {
  code: "",
  description: "",
  height: "",
};

export const initialUnderCarriageMeta = initialListPaginationMeta;

export const initialState: UnderCarriageState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialUnderCarriageMeta,
  error: null,
  isAddModalOpen: false,
  form: initialUnderCarriageForm,
};
